import { gql, useMutation, useQuery } from "@apollo/client";
import { MeQuery } from "../gql/graphql";

const SET_IS_READ_MUTATION = gql`
  mutation SetIsRead($id: Float!) {
    setIsRead(id: $id) {
      ok
      err
    }
  }
`;

export interface SetReadMutation {
  setIsRead: {
    ok: boolean;
    err: string;
  };
}

export interface SetReadMutationVariables {
  id: number;
}

export const useSetRead = (onCompleted?: (data: SetReadMutation) => void) => {
  return useMutation<SetReadMutation, SetReadMutationVariables>(
    SET_IS_READ_MUTATION,
    { onCompleted }
  );
};
